import { createContext, type MutableRefObject } from 'react'

type FormFieldContextValue = {
  name: string
  fieldId?: string
  formElementRef: MutableRefObject<unknown>
  onFocus?: () => void
  onBlur?: () => void
}

export const FormFieldContext = createContext<FormFieldContextValue>(
  undefined as unknown as FormFieldContextValue
)
